export const TranslationKeys = {
  pauseLabel: 'TextOnPath_AriaLabel_Pause',
  playLabel: 'TextOnPath_AriaLabel_Play',
  namespace: 'ariaLabels',
};
